import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import clsx from 'clsx';

import { useGetCurrencySymbol } from 'hooks/useGetCurrencySymbol';

import styles from './CurrencyLabelComponent.module.scss';

export const CurrencyLabelComponent: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { t } = useTranslation();
  const currencySymbol = useGetCurrencySymbol();

  return (
    <Typography variant="subtitle1" className={clsx(styles.label, { [styles.disabled]: disabled })}>
      {t('currencySelector', { currency: currencySymbol })}
    </Typography>
  );
};
